import { signal, computed } from "@preact/signals-react";

import IconTable from "components/Icons/IconTable";
import TableRow from "components/MeTable/TableRow";
import FactoryCell from "components/MeTable/FactoryCell";
import { triggerMethod } from "tools/helpers";
import { useWizardStore } from "store/wizardStore";

function BodyTable(props) {
  const {
    parentRec,
    records,
    ctxView,
    onActionButton,
    selectable,
    onClickCell,
    updateRecords,
    reloadRecords,
    fieldName,
    level,
  } = props;
  const { webtree, webfields, model, table_action, access } = ctxView;
  const { record: recordWizard, store: storeWizard } = useWizardStore();
  const selectedRows = signal(
    recordWizard?.selectedRows ? new Map(recordWizard.selectedRows) : new Map(),
  );

  const cellButtonStart = [];
  const cellButtonEnd = [];
  if (table_action) {
    for (const buttonType of table_action) {
      if (buttonType === "add" || buttonType === "date-card") {
        continue;
      } else if (buttonType === "edit" || buttonType === "open") {
        cellButtonStart.push(buttonType);
      } else if (buttonType === "delete") {
        // const accessDelete = access?.delete
        //   ? access.delete(parentRec.record)
        //   : true;
        // if (accessDelete)
        cellButtonEnd.push(buttonType);
      } else {
        cellButtonEnd.push(buttonType);
      }
    }
  }

  const treeView = webtree.map((val) => {
    return { ...webfields[val.name], ...val };
  });

  function actionButton(rec, value) {
    if (value === "delete" && access?.delete && !access.delete(rec)) {
      return <td key={value} className="text-center w-11"></td>;
    }
    if (value === "edit" && access?.edit && !access.edit(rec)) {
      return <td key={value} className="text-center w-11"></td>;
    }
    return (
      <td key={value} className="text-center w-11">
        <IconTable name={value} record={rec} onClickButton={onActionButton} />
      </td>
    );
  }

  async function triggerAction(record, method) {
    if (typeof method !== "string") {
      await method(record);
      return;
    }
    await triggerMethod(model, method, record, false);
    reloadRecords();
  }

  function onDoubleClickRow(rec) {
    if (props.onDoubleClick) {
      props.onDoubleClickRow(rec);
    }
  }

  function onClickRow(rec) {
    if (!selectable) {
      return;
    }
    let selectedRows_ = recordWizard.selectedRows ?? new Map();
    const current = new Map(selectedRows.value);
    if (selectable === "multi") {
      if (current.has(rec.id)) {
        selectedRows_.delete(rec.id);
        current.delete(rec.id);
      } else {
        selectedRows_ = selectedRows_.set(rec.id, rec);
        current.set(rec.id, rec);
      }
    } else {
      current.clear();
      current.set(rec.id, rec);
      selectedRows_ = new Map([[rec.id, rec]]);
    }
    selectedRows.value = current;
    if (props.onClickRow) {
      props.onClickRow(rec);
    }

    // Call updateWizard is an error because rerender all form / table,
    // and after close modals automatically
    // updateWizard({ selectedRows: selectedRows_ });
    recordWizard.selectedRows = selectedRows_;
    storeWizard.selectedRows = selectedRows_;
  }

  function onChange(field, value, rec) {
    if (updateRecords) {
      updateRecords(field, value, rec.id);
    }
  }

  function handleCheck() {}

  function DataRow({ idx, record, treeView, parentRec }) {
    const isChecked = computed(() => selectedRows.value.has(record.id));

    return (
      <TableRow
        key={idx}
        selected={isChecked}
        record={record}
        selectable={selectable}
        readOnly={props.readOnly}
        onClick={onClickRow}
        onDoubleClick={onDoubleClickRow}
      >
        {selectable === "multi" && (
          <td className="text-center w-10">
            <input
              key={record.id}
              type="checkbox"
              name={"selectable"}
              onChange={handleCheck}
              checked={isChecked.value}
              className="h-4 w-4 rounded-lg accent-amber-400"
            />
          </td>
        )}
        {cellButtonStart.map((value, index) =>
          actionButton(record, value, index),
        )}
        {treeView.map((field, key) => {
          return (
            <FactoryCell
              key={key}
              record={record}
              field={field}
              level={level}
              model={model}
              parentRec={parentRec}
              fieldName={fieldName}
              triggerAction={triggerAction}
              onClickCell={onClickCell}
              onChange={(f, v, rec) => onChange(f, v, rec)}
            />
          );
        })}
        {cellButtonEnd.map((value, index) =>
          actionButton(record, value, index),
        )}
      </TableRow>
    );
  }

  const iterableRecords = Array.isArray(records)
    ? records
    : records instanceof Map
      ? Array.from(records.values())
      : records instanceof Set
        ? Array.from(records)
        : [];

  return (
    <tbody>
      {iterableRecords.map((rec, i) => (
        <DataRow
          key={rec.id}
          idx={i}
          record={rec}
          treeView={treeView}
          parentRec={parentRec}
        />
      ))}
    </tbody>
  );
}

export default BodyTable;
